module.exports = __webpack_public_path__ + "static/media/1 0 Orddiktat Intro-norming.4a5784eb.mp3";